export const API_URL: string = "https://analyzer.inkprimelo.com.mx/api/?";
export const GET_FILTER: string = "_GET&filter=";
export const POST_FILTER: string = "_POST&filter=";
export const FILE_FILTER: string = "_FILE";
export const CLOUD_FUNCTION: string = "cloudFunction=";
export const HOOK_FUNCTION: string = "hook=";
export const COMPANY_NAME: string = "Mercado Alerta";
export const STORES: any[] = [
  {
    name: "Compra 1",
    code: "TG-63dbf9b6020ef300010d8d2d-1168840517",
    accesToken: null,
  },
  {
    name: "Compra 2",
    code: "TG-63dbfa0e26b31600012a8e5c-1171853402",
    accesToken: null,
  },
  {
    name: "Computoner 1",
    code: "TG-63dbfa3985fff90001070544-1168910103",
    accesToken: null,
  },
  {
    name: "Computoner 2",
    code: "TG-63dbfa5a808f8f00016e3a4c-1171847340",
    accesToken: null,
  },
  {
    name: "Libreria",
    code: "TG-63dbfa7926b31600012a8ff3-1084164701",
    accesToken: null,
  },
  {
    name: "Ofertoner 3",
    code: "TG-63dbfa96808f8f00016e3b28-1168516348",
    accesToken: null,
  },
  {
    name: "Ofertoner 4",
    code: "TG-63dbfaca3593b90001d7eeb7-1208984783",
    accesToken: null,
  },
  {
    name: "Ofertoner 6",
    code: "TG-63dbfaf2808f8f00016e3c6b-1216164526",
    accesToken: null,
  },
  {
    name: "Ofertoner 7",
    code: "TG-63dbfb2c020ef300010d92c3-1216208846",
    accesToken: null,
  },
];



// WEBPACK FOOTER //
// ./src/utils/constants.ts